<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 培训 -->
    <div class="div">
      <div class="across"></div>
      <div class="tabs">
        <div class="crumbs">
          <span>
            <!-- <router-link :to="{ path: '/' }"> -->
            <img src="../../assets/images/header/white.png" alt="logo" />
            首页
            <!-- </router-link> -->
          </span>
          <!-- &gt;
          <span @click="activeName = 'one'" style="cursor: pointer">培训</span> -->
          &gt;
          <span>{{ text }}</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="培训" name="two">
            <div class="videoTeaching" v-if="show">
              <div
                class="videos"
                v-for="(item, index) in videos"
                :key="index"
                @click="videoBtn(index)"
              >
                <div class="pic">
                  <img
                    :src="item.src"
                    alt="没得呀"
                    title="点击跳转视频播放页面"
                  />
                </div>
                <div class="icon">
                  <!-- el-icon-video-play -->
                  <span></span>
                </div>
                <div class="text">
                  <div class="title">{{ item.title }}</div>
                  <div class="data">{{ item.text }}</div>
                </div>
              </div>
            </div>
            <div class="paging">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      activeName: "two",
      text: "培训",
      active: 0,
      videos: [
        {
          src: require("../../assets/images/dynamicInformation/video/img001.png"),
          title: "都说企业停产、人宅家，那污染从哪里来？",
          text: "不上班还有雾霾，到底是为啥？节前很多农村也不准放鞭炮，过了三十开始人也不走动了，车也不开了，工厂都放假了，但空气依旧浑浊。",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img002.png"),
          title: "中国大气污染治理历程",
          text: "数据由各级生态环境部门发布的实时空气质量统计而成，其中2020年数据截止12月27日。",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img004.png"),
          title: "泄漏检测与修复(LDAR)的现状和发展",
          text: "从2013年中国陆续开展LDAR项目以来,对设备的泄漏的综合管理起到了积极作用。截止2016年低,重点行业的首轮LDAR工作基本完成。首轮LDAR工作的VOCs减排率在30-50%,部分企业甚至达到70%。有效减少了VOCs的排放。",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img005.png"),
          title: "“环保管家”工作内容如何从“虚”向“实”",
          text: "“环保管家”,即环境管理服务,是指环保服务企业为政府或企业提供综合环保一站式托管服务,统筹解决企业或政府面临的环境问题;提高决策科学性,有效降低企业环保管理成本;提升企业环境面貌,解决企业因环保而带来的烦恼。 ",
        },
        {
          src: require("../../assets/images/dynamicInformation/video/img006.png"),
          title: "石化企业VOCs要点解读",
          text: "2017-2018年采暖季期间(11月15日-次年3月15日),京津翼及周边地区大气污染传输通道城市(“2+26”城市) PM2.5的平均浓度为85微克/立方米,其中有机物、硝酸盐、硫酸盐、按盐等主要组分的占比分别为28%,19%,12%和11%,揭示京津翼大气PM2.5化学特征发生了显著变化,2018年11月-2019年2月主要站点在线测量的结果再次印证了这一变化规律。",
        },
        // {
        //   src: require("../../assets/images/dynamicInformation/video/img003.png"),
        //   title: "环保讲坛，以智能管理助力环保行业",
        //   text: "以工匠精神带动品质革命，以智能管理助力环保行业，创新永无止境。",
        // },
        // {
        //   src: require("../../assets/images/dynamicInformation/video/img007.png"),
        //   title: "“一企(厂)一策”开展方法和实例分析",
        //   text: "中华环保联合会VOCs污染防治专业委员会,是中华环保联合会在VOCs污染防治领域成立的专业分支机构,是中华环保联合会在大气污染防治领域职能的延伸和支撑。由从事VOCs污染防治技术与产业研究、开发、服务、工程、投资的企业、事业单位,社团组织和相关单位为实现共同意愿而自愿组成的。 ",
        // },
      ],
      show: true,
      pageSize: 9,
      total: 0,
    };
  },

  created() {
    this.$store.state.menu = 5;
  },

  mounted() {},

  methods: {
    mouse(e) {
      this.active = e;
    },
    handleClick() {
      this.active = 0;
    },
    videoBtn(e) {
      let detailUrl = this.$router.resolve({
        path: "/videoPage",
        query: { id: e },
      });
      window.open(detailUrl.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  .head {
    position: fixed;
    width: 100%;
    height: 100px;
    background-color: #fff;
    z-index: 5;
    color: #333;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
  .div {
    width: 100%;
    padding-top: 100px;
    .across {
      width: 100%;
      height: 50px;
      background-color: #0064a1;
    }
    .tabs {
      position: relative;
      padding: 0 50px;
      max-width: 1200px;
      min-width: 900px;
      margin: auto;
      margin-top: -45px;
      .videoTeaching {
        margin-top: 100px;
        margin-bottom: 50px;
        width: 100%;
        height: 100%;
        .videos {
          position: relative;
          float: left;
          width: 33.33%;
          // width: 28%;
          height: 260px;
          margin-bottom: 50px;
          cursor: pointer;
          transition: 0.3s;
          -moz-transition: 0.3s; /* Firefox 4 */
          -webkit-transition: 0.3s; /* Safari 和 Chrome */
          -o-transition: 0.3s; /* Opera */
          .pic {
            width: 90%;
            max-height: 175px;
            margin: auto;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .icon {
            position: absolute;
            top: 60px;
            left: 50%;
            transform: translate(-50%);
            z-index: 2;
            width: 40px;
            height: 40px;
            border-radius: 20px;
            background-color: rgba(255, 255, 255, 0.2);
            // color: #fff;
            // font-size: 40px;
            span {
              position: absolute;
              top: 11px;
              left: 15px;
              display: inline-block;
              border: 8px solid transparent;
              border-right: 14px solid transparent;
              border-left: 14px solid #fff;
            }
          }
          .text {
            width: 80%;
            height: 14%;
            line-height: 1.5;
            color: #333;
            padding: 10px 0px;
            margin: auto;
            .title {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.5;
              color: #333333;
              padding-bottom: 5px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .data {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.5;
              color: #666666;
              overflow: hidden;
              text-indent: 2em;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
        .videos:hover {
          // box-sizing: border-box;
          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
          margin-top: -2px;
          transition: 0.3s;
          -moz-transition: 0.3s; /* Firefox 4 */
          -webkit-transition: 0.3s; /* Safari 和 Chrome */
          -o-transition: 0.3s; /* Opera */
          padding-bottom: 2px;
        }
      }
    }
  }
  .crumbs {
    position: absolute;
    right: 50px;
    line-height: 40px;
    z-index: 2;
    color: #fff;
    font-size: 16px;
  }
  .router-link-active {
    text-decoration: none;
    color: #fff;
  }
  // tabs标题的字号
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>
